<template>
  <section>
    <div class="row">
      <div class="col px-5">
        <div class="row justify-content-center">
          <div class="col-lg-10 col-12">
            <div class="row justify-content-end align-items-center mt-5 mb-4">
              <div class="col">
                <h3 class="mb-0 text-danger font-weight-bold">
                  Rekomendasi Prodi {{ courseCategory.name }}
                </h3>
              </div>
              <div class="col-auto ml-auto">
                <form class="form-inline" v-on:submit.prevent="paginate(1)">
                  <div class="row align-items-center">
                    <div class="col-auto pr-1">
                      <label class="text-muted">Cari</label>
                    </div>
                    <div class="col px-1">
                      <input
                        v-model="form.keyword"
                        class="form-control form-control-sm"
                        placeholder="Search..."
                      />
                    </div>
                    <div class="col-auto pl-1">
                      <button type="submit" class="btn btn-danger btn-sm px-3">
                        Search
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div id="table-primary" class="table-responsive px-2">
                  <table class="table">
                    <thead>
                      <tr class="text-danger font-weight-bold">
                        <th scope="col">Program Studi</th>
                        <th scope="col">Nama PTN</th>
                        <th scope="col">NBA</th>
                        <th scope="col">Akreditasi</th>
                        <th scope="col">Daya Tampung SBMPTN 2024</th>
                        <th scope="col">Peminat 2023</th>
                      </tr>
                    </thead>
                    <tbody class="font-weight-medium">
                      <tr
                        class="shadow-sm"
                        v-for="universityCourse in universityCourses"
                      >
                        <td class="text-center py-4">
                          <router-link
                            v-bind:to="{
                              name: 'program-study/view',
                              params: {
                                type: universityCourse.course.department
                                  .courseCategoryID,
                                id: universityCourse.courseID,
                              },
                            }"
                            class="text-loading"
                            >{{ universityCourse.name }}</router-link
                          >
                        </td>
                        <td class="py-4">
                          <span class="text-loading">{{
                            universityCourse.university.name
                          }}</span>
                        </td>
                        <td class="py-4">
                          <span
                            v-if="universityCourse.nba"
                            class="text-loading"
                            >{{ universityCourse.nba }}</span
                          >
                          <i class="fa fa-minus" v-else></i>
                        </td>
                        <td class="py-4">
                          <span
                            class="text-loading"
                            v-if="universityCourse.accreditation"
                            >{{ universityCourse.accreditation }}</span
                          >
                          <i class="fa fa-minus" v-else></i>
                        </td>
                        <td class="py-4">
                          <span
                            class="text-loading"
                            v-if="universityCourse.graduates"
                            >{{ universityCourse.graduates }}</span
                          >
                          <i class="fa fa-minus" v-else></i>
                        </td>
                        <td class="py-4">
                          <span
                            class="text-loading"
                            v-if="universityCourse.keketatan"
                            >{{ universityCourse.keketatan }}</span
                          >
                          <i class="fa fa-minus" v-else></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col mb-4">
                <nav class="float-right">
                  <paginate
                    v-model="page"
                    next-text="<i class='fa fa-chevron-right'></i>"
                    prev-text="<i class='fa fa-chevron-left'></i>"
                    v-bind:click-handler="paginate"
                    v-bind:page-count="pageCount"
                    container-class="pagination pagination-sm"
                    page-class="page-item"
                    prev-class="page-item"
                    v-bind:next-class="'page-item'"
                    page-link-class="page-link"
                    prev-link-class="page-link"
                    next-link-class="page-link"
                    v-bind:hide-prev-next="true"
                  >
                  </paginate>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col text-center mt-5">
        <Adsense
          v-bind:data-ad-client="googleAdsClientKey"
          data-ad-slot="6426122373"
        ></Adsense>
      </div>
    </div>
  </section>
</template>

<script>
import Paginate from "vuejs-paginate";

export default {
  name: "AccountStudentRecommendationIndex",
  components: {
    Paginate,
  },
  data() {
    return {
      form: {
        keyword: "",
      },
      courseCategory: {},
      universityCourses: [],
      pageCount: 10,
      page: 1,
      googleAdsClientKey: process.env.GOOGLE_ADS_CLIENT,
    };
  },
  methods: {
    paginate(page, scroll = true) {
      this.axios
        .get(process.env.API_URL + "/student/course-recommendation", {
          params: Object.assign({}, this.form, {
            page: page,
            courseCategoryID: this.courseCategory.id,
          }),
        })
        .then((response) => {
          this.universityCourses = response.data.data.data;
          this.pageCount = response.data.data.total
            ? response.data.data.last_page
            : 0;

          if (scroll) {
            document.getElementById("table-primary").scrollIntoView();
            var headerElement = document.getElementsByTagName("nav");
            if (headerElement.length) {
              window.scrollBy(0, headerElement[0].offsetHeight * -1);
            }
          }
        });
    },
  },
  created() {
    this.axios
      .get(process.env.API_URL + "/course-category")
      .then((response) => {
        this.courseCategory = response.data.data.find(
          (courseCategory) =>
            courseCategory.id === parseInt(this.$route.params.type)
        );
        if (!this.courseCategory) {
          this.$router.replace({
            name: "error",
            params: { code: 404, message: "Program Study not found" },
          });
        }
        this.paginate(1, false);
        document.title =
          "Rekomendasi Prodi " +
          this.courseCategory.name +
          " - " +
          process.env.APP_NAME;
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/account/student/recommendation/Index.vue